@if (this.bewegung(); as bewegung) {
  <div class="flex flex-col flex-grow overflow-auto h-full full-width w-full z-[0] lg:-mt-3 relative">
    @if ((loading$ | async) === false) {
      <div
        class="flex flex-col w-full flex-grow -mt-3 px-4">
        <div class="flex flex-col gap-2 w-full h-full mt-2 mb-4">
          <div class="flex flex-row w-full justify-between">
            <div class="font-bold text-sm text-primary-400">
              {{'#LLR_KOMMISSIONIERUNG.ARTIKELDATEN_EINGABE.TITEL_MENGE' | translate}}
            </div>
            @if (bewegung?.kommissionierDaten?.menge_pro_palette && (bewegung?.kommissionierDaten?.arteh?.arteh !== bewegung?.kommissionierDaten?.arteh_palette?.arteh)) {
              <div
                class="font-bold text-sm text-primary-400">
                {{'#LLR_KOMMISSIONIERUNG.ARTIKELDATEN_EINGABE.TITEL_MENGE_PRO' | translate}} {{bewegung?.kommissionierDaten?.arteh_palette?.arteh ?? '' | uppercase}}):
                {{bewegung?.kommissionierDaten?.menge_pro_palette}} {{bewegung?.kommissionierDaten?.arteh?.arteh ?? 'Stk'}}
              </div>
            }
          </div>
          <soft-mengen-eingabe
            #mengeArtikel
            [class]="'w-full'"
            [float]="true"
            [value]="bewegung?.kommissionierDaten?.menge ?? 0"
            [einheit]="bewegung?.kommissionierDaten?.arteh?.arteh ?? ''"
            (valueChange)="updateMengeLocal(bewegung, mengeArtikel.value ?? 0)">
          </soft-mengen-eingabe>
          @if (bewegung?.bewebs?.artikel?.kzgewichtsartikel === 'N' &&
            (bewegung?.bewebs?.artikel?.artikelLlr?.kzpalettenteilung_ek === 'J' ||
            (bewegung?.bewebs?.artikel?.artikelLlr?.kzpalettenteilung_ek === 'N' && !paletteEinzelEingabe)) &&
            (bewegung?.kommissionierDaten?.arteh?.arteh !== bewegung?.kommissionierDaten?.arteh_palette?.arteh) &&
            (bewegung?.kommissionierDaten?.menge_pro_palette ?? 0 > 0)) {
            <div
              class="font-bold text-sm text-primary-400 mx-auto">
              = {{ calculatedAnzahlPaletten }} {{bewegung?.kommissionierDaten?.arteh_palette?.arteh}},
              {{ mengeArtikel?.value === 0 ? 0 : calculatedAnzahlRestmenge }} {{bewegung?.kommissionierDaten?.arteh?.arteh ?? 'Stk'}}
            </div>
          }
          @if (bewegung?.bewebs?.artikel?.kzgewichtsartikel === 'J') {
            <div
              class="font-bold text-sm text-primary-400">
              {{'#LLR_KOMMISSIONIERUNG.ARTIKELDATEN_EINGABE.TITEL_GEWICHT' | translate}}
            </div>
            <soft-mengen-eingabe
              #gewichtArtikel
              [class]="'w-full'"
              [float]="true"
              [value]="kommissionierGewichtLocal ?? bewegung?.kommissionierDaten?.gewicht ?? 0"
              [einheit]="'KG'"
              [disabled]="!gewichtEditable"
              (valueChange)="updateGewichtLocal(bewegung, gewichtArtikel.value ?? 0)">
            </soft-mengen-eingabe>
            @if (gewichtArtikel.value <= 0) {
              <div
                class="font-bold text-sm text-red-800 mt-1">
                {{'#LLR_KOMMISSIONIERUNG.ARTIKELDATEN_EINGABE.LABEL_GUELTIGES_GEWICHT_EINGEBEN' | translate}}
              </div>
            }
          }
          @if (((this.palettenVorhanden() === 'false') && vorhandenePalettenAuswaehlbar)) {
            <div
              class="font-bold text-sm text-red-800 mb-2 mt-auto mx-auto">
              {{'#LLR_KOMMISSIONIERUNG.ARTIKELDATEN_EINGABE.LABEL_KEINE_PALETTEN_VORHANDEN' | translate}}
            </div>
          }
        </div>
      </div>
    } @else {
      <div class="p-4">
        <div class="flex flex-col gap-2" *softRepeat="2">
          <div class="h-4 w-16 skeleton rounded"></div>
          <div class="flex soft-card rounded w-full h-24 mb-3">
            <div class="flex flex-col gap-2 items-start pb-1.5 pt-2">
              <div class="h-4 w-20 skeleton rounded"></div>
              <div class="h-4 w-24 skeleton rounded"></div>
              <div class="h-4 w-36 skeleton rounded"></div>
            </div>
          </div>
        </div>
        <div class="flex flex-col gap-2 mt-3" *softRepeat="3">
          <div class="h-4 w-16 skeleton rounded"></div>
          <div class="flex rounded bg-white w-full h-24"></div>
        </div>
      </div>
    }
  </div>
}
